module.exports = __webpack_public_path__ + "img/poweroff.f9f9085a.svg";